var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-list',{attrs:{"size":"small","loading":_vm.loading,"data-source":_vm.resultList},scopedSlots:_vm._u([{key:"renderItem",fn:function(item){return _c('a-list-item',{},[_vm._v(" "+_vm._s(item)+" ")])}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }